module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('strong', [_vm._v(_vm._s(_vm.counter))]), _vm._v(" " + _vm._s(_vm.$root.plural(_vm.counter, 'application.charcounter.remaining', _vm.zero())) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aca5de42"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/shareds/char-counter/CharCounter.vue
// module id = 820
// module chunks = 1